import request from './request'

export function listProduct(data) {
  return request.post('/mes/products/list', data)
}
export function selectProduct(entityType) {
  return request.get('/mes/products/select', { params: { entityType } })
}
export function getProduct(id) {
  return request.get('/mes/products/' + id)
}
export function saveProduct(data) {
  return request.post('/mes/products', data)
}
export function updateProduct(data) {
  return request.post('/mes/products/update', data)
}
export function deleteProduct(ids) {
  return request.post('/mes/products/delete', ids)
}
export function configureProduct(data) {
  return request.post('/mes/products/configure', data)
}
